import { render, staticRenderFns } from "./data-users.vue?vue&type=template&id=83bdd062"
import script from "./data-users.vue?vue&type=script&lang=js"
export * from "./data-users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports